


































































































import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';
import { Row } from '@/main/utils/table';
import Save from '#components/dms/button/Save.vue';
import { deleteButton, infoButton, submitButton } from '@/main/utils/tableOperations';
import _ from 'lodash';
import { apiProvider } from './api';
import { NAME as name, UPLOADED_BULKINVENTORY_ERROR, 
	UPLOADED_BULKINVENTORY, EXPORT_INVENTORY_COLUMN,
	FILE_NAME, ERROR_COUNT,
	APPROVED, PENDING, DRAFT,STATUS, 
	DELETE_COFIRM_MESSAGE, SURE_TO_DELETE_CONFIRM,
	CONFIRM,
	ZERO_ERROR_COUNT,
	DMS3_INFO_TITLE,
	NOT_IN_DRAFT_STATUS,
	ALREADY_APPROVED_INADMISSIBLE,
	ALREADY_SUBMITTED_INADMISSIBLE,
	ZERO_RECORD_INADMISSIBLE,
	APPROVAL_NOTE,
	ERROR_INADMISSIBLE,
	SELECT_WAREHOUSE,
	FILE_UPLOAD_SUCCESS,
	NO_DATA_FILE,
	SELECT_FILE,
	REJECTED,
	ALREADY_REJECTED_INADMISSIBLE,
	BULK_INVENTORY_FILE_DELETION_ERROR_MESSAGE,
	UNABLE_TO_UPLOAD,
	UNABLE_TO_EXPORT
 } from './constants';
import { store } from './store/list';
import { MAXIMUM_FILE_SIZE, ScreenSize } from '@/main/components/constants';
import { handleChange, handleRemove, validateFiletypeForXLSX } from '@/main/utils/fileHelper';
import { dropdownList } from './store/state';
import { Pagination } from 'element-ui';
import { ERROR } from '@/main/store/actionTypes';
import Upload from '@/main/components/dms/form/Upload.vue';
export const TABLE_DATA = <const>'TABLE_DATA';

export default listFactory(name, store).extend({
	components: {
		'dms-save': Save,
	},
	data() {
		return {
			workshopName: '',
			warehouseName: '',
			fileName: '',
			noOfRecord: null as number | null,
			errorLog: '',
			createdByUser: '',
			createdDate: '',
			Remark: '',
			fileList: [] as any[],
			UploadAll: false,
			dependencies: {},
			screenSize: ScreenSize.MEDIUM,
			windowWidth: window.innerWidth,
			showErrorTableDialogHeaderText: UPLOADED_BULKINVENTORY_ERROR,
			errorTableKey:'0',
			errorTable:[],
			showErrorTableDialog: false,
			errorTableloading: true,
		};
	},
	mounted() {
		// Need to call specifically as List page does not have filter intialization method
		this.getWHListForUploadBulkInventoryDropDown();
		this.getDropdownListForWarehouse();
		if (!this.localState.pageLoaded) {
			this.localState.pageLoaded = true;
		}
	},
	computed: {
		tableListeners(): {} {
			return {
				sideBarSelectRow: this.sideBarSelectRow,
				'save-column-setting': this.saveColumnSetting,
				sumbitClick: this.submitItem,
				deleteClick: this.deleteItem,
			};
		},

		isUploadDisabled(): boolean {
			return !this.filter.BulkInventoryPrp || this.fileList.length === 0;
		},
		isModified(): boolean {
			return this.table.isModified();
		},
		isTableDataNotPresent(): boolean {
			return !this.table.rows?.length;
		},
		rows(): Row[] {	
			return this.table.rows;
		},
		extraButtons(): any {
			return {
				...submitButton((e: any, cells: any) => this.submitItem(
					cells[this.table.cellNames!.ID]
					,cells
				)),
				...deleteButton((e: any, cells: any) => this.deleteItem(
					cells[this.table.cellNames!.ID]
					,cells
				)),
				...infoButton((e: any, cells: any) => this.getErroInfo(
					cells[this.table.cellNames!.ID]
					,cells
				)),
			};
		},
	},
	methods: {
		onErrorTableDialogClosed() {
			this.errorTableloading = false;
		},
		getWidth() :string {
			return '100%';
		},
		async CellClick({ row, column }: { row: any , column: any}){
			const uploadIdIndex: number = this.table.cellNames!.ID;
			//this.table.cellNames!.ERROR_COUNT; this gives cell index in current row starts with 0
			const errCountColId: number = this.table.cellNames!.ERROR_COUNT;
			const errorCount = row.cells[errCountColId]
			const uploadedBulkInventoryId:number= row.cells[uploadIdIndex];		
			try {
					this.startLoading();
					if(column.label === this.LocalizePopisPoli(FILE_NAME))	
					{
						await apiProvider.exportBulkInventoryUserUploadedData(uploadedBulkInventoryId);
					}
					if(column.label === this.LocalizePopisPoli(ERROR_COUNT) && errorCount > 0 )
					{
						await apiProvider.exportBulkInventoryErrors(uploadedBulkInventoryId);
					}
				} 
				catch (error) {
						showAlert({
                            message: 'In a catch block, something went wrong in CellClick.',
							title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
							options: {
								type: 'info',
							},
						});
					} 
			finally { 	
						this.endLoading();
			}
		},
		async getErroInfo(uploadedBulkInventoryId: number, currentRow: any) {
			const totalErrorColIndex: number = this.table.cellNames!.ERROR_COUNT;
			const totalErrors = currentRow[totalErrorColIndex];
			if (!totalErrors)
			{
				showAlert({
					message: this.LocalizeChyboveHlasky(ZERO_ERROR_COUNT),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
						type: 'info'
					},
				});
				return;
			}
			this.startLoading();
			this.errorTableloading = true;
			this.errorTable = [];
				try {
					const { data } = await apiProvider.getBulkInventoryErrors(uploadedBulkInventoryId);
					this.errorTable = data || [];
					this.showErrorTableDialog = true;
				}
				catch (error) {
					showAlert({
						message: 'Something went wrong in getErroInfo.',
						title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
						options: {
							type: 'info'
						},
					});
				}
				finally {
					this.errorTableloading = false;
					this.endLoading();
				}
		},
		async submitAttachmentUpload() {
			// validaiton, warehouse is required.
			if (_.isNil(this.localState.UploadWarehouseId) || this.localState.UploadWarehouseId == 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky(SELECT_WAREHOUSE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
						type: 'info',
					},
				});
				return;
			}
			console.log(this.fileList.length);
			const file = this.fileList[0];
			if (file) {
				let fileValidation = validateFiletypeForXLSX(file);
				if (fileValidation.result) {
					try{
						this.startLoading();
						const { data: uploadResult } = await apiProvider.uploadCorrectedInventory(file, this.localState.UploadWarehouseId);
							if (uploadResult) {
								this.localState.UploadWarehouseId = 0;
								await this.getWHListForUploadBulkInventoryDropDown();
								this.fileList = [];
								await this.tableData();
								if (uploadResult) {
									showAlert({
										message: uploadResult,
										title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
										options: { type: 'info' },
									});
								}	
							}
					}
					catch (error){
						showAlert({
                            message: this.LocalizePopisPoli(UNABLE_TO_UPLOAD),
							title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
							options: {
								type: 'info',
							},
						});
					}
					finally{
						this.endLoading();
					}
				} else {
					if(fileValidation.result === false && fileValidation.message && fileValidation.message.length > 0) {
						if(fileValidation.message === 'InvalidFileType')
						{
								showAlert({
								message: this.LocalizeChyboveHlasky('EdlFileBadExtension').replace('{0}', `xlsx`),
								title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
								options: {
									type: 'info',
								},});
								return false;
						}
						else if(fileValidation.message === 'FileSizeExceeded')
						{
							showAlert({
								message: this.LocalizeChyboveHlasky(fileValidation.message),
								title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
								options: {
									type: 'info',
								},});
								return false;
						}
					};
					this.fileList = [];
					showAlert({
						message: this.LocalizeChyboveHlasky(NO_DATA_FILE),
						title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
						options: {
							type: 'info',
						},
					});
				}
			} else {
				// validaiton: File must be selected for upload
				showAlert({
					message: this.LocalizeChyboveHlasky(SELECT_FILE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
						type: 'info',
					},
				});
			}
		},
		async deleteItem(uploadedId: number | number, currentRow: any) {
			const statusColIndex: number = this.table.cellNames!.STATUS;
			const currentFileStatus = currentRow[statusColIndex];
			if(currentFileStatus == DRAFT)
			{
				this.showConfirm({
					message:  this.LocalizePopisPoli(DELETE_COFIRM_MESSAGE),
					title: this.LocalizeChyboveHlasky(SURE_TO_DELETE_CONFIRM),
					options: {
						confirmButtonText: this.Localize('Ano'), // Yes
						cancelButtonText: this.Localize('Ne'),   // No
						callback: async (action: string | string ) => {
							if (action === CONFIRM) {
								try {
									this.startLoading();
										await apiProvider.deleteBulkUploadedPartsInventory(uploadedId);
										await this.getWHListForUploadBulkInventoryDropDown();
										await this.tableData();
									} catch (error) {
										showAlert({
												message:  this.LocalizeChyboveHlasky(BULK_INVENTORY_FILE_DELETION_ERROR_MESSAGE),
												title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
												options: {
													type: 'info',
												},
											});
									} 
									finally {
										this.endLoading();
									}
							}
						}
					},
				});

			 }
			 else
			 {
				showAlert({
							message: this.LocalizeChyboveHlasky(NOT_IN_DRAFT_STATUS),
							title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
							options: {
								type: 'info',
							},
						});
				return;
			 }
			 return;
		},
		async submitItem(uploadedId: number | number, currentRow: any) {
			const errorCountColIndex: number = this.table.cellNames!.ERROR_COUNT;
			const currentRowErrorCount: number = currentRow[errorCountColIndex];

			const totalRecordsColIndex: number = this.table.cellNames!.TOTAL_RECORDS;
			const totalRecordsCount: number = currentRow[totalRecordsColIndex];
			
			const statusColIndex: number = this.table.cellNames!.STATUS;
			const currentFileStatus = currentRow[statusColIndex];

			if(currentFileStatus == APPROVED)
			{
				showAlert({
					message: this.LocalizeChyboveHlasky(ALREADY_APPROVED_INADMISSIBLE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
								type: 'info',
					},
				});
				return ;
			}
			else if(currentFileStatus == REJECTED)
			{
				showAlert({
					message: this.LocalizeChyboveHlasky(ALREADY_REJECTED_INADMISSIBLE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
								type: 'info',
					},
				});
				return ;
			}
			else if (currentFileStatus == PENDING){
				showAlert({
					message: this.LocalizeChyboveHlasky(ALREADY_SUBMITTED_INADMISSIBLE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
								type: 'info',
					},
				});
				return;
			}
			if(totalRecordsCount == 0)
			{
				showAlert({
					message: this.LocalizeChyboveHlasky(ZERO_RECORD_INADMISSIBLE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
								type: 'info',
					},
				});
				return ;
			}
			if(currentRowErrorCount === 0 && currentFileStatus == DRAFT)
			{
					this.showConfirm({
					message:  this.LocalizePopisPoli(APPROVAL_NOTE),
					title: this.LocalizeChyboveHlasky(SURE_TO_DELETE_CONFIRM),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
						callback: async (action: string | string ) => {
							if (action === CONFIRM) {
								try {
										this.startLoading();
										const result = await apiProvider.submitBulkUploadedPartsInventoryForApproval(uploadedId);
										if (result && result.data && result.data.success === false && result.data.warning) {
											showAlert({
												message: this.LocalizeChyboveHlasky(result.data.warning),
												title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
												options: { type: 'info' },
											});
											return;
										}
										await this.getWHListForUploadBulkInventoryDropDown();
										await this.tableData();
									} catch (error) {
										showAlert({
												message: 'something went wrong while submitting bulk inventory in submitItem.',
												title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
												options: {
															type: 'info',
												},
											});
									} 
									finally {
										this.endLoading();
									}
							}
						}
					},
				});
			}
			else
			{
				showAlert({
					message: this.LocalizeChyboveHlasky(ERROR_INADMISSIBLE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
								type: 'info',
					},
				});
				return ;
			}
		},
		async exportPartsInventoryByWarehouse() {
			if (_.isNil(this.localState.WarehouseId) || this.localState.WarehouseId == 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky(SELECT_WAREHOUSE),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
						type: 'info',
					},
				});
			}
			else {
				try {
					this.startLoading();
					let warehouseName: any = this.dropdownList.WarehouseId
						.find((item: any) => item.Value === this.localState.WarehouseId)!.Text;
					await apiProvider.exportPartsInventoryByWarehouse(this.localState.WarehouseId, warehouseName);
					this.localState.WarehouseId = 0;
				} catch (error) {
					showAlert({
								message: this.LocalizePopisPoli(UNABLE_TO_EXPORT),
								title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
								options: {
											type: 'info',
										},
							});
				} 
				finally {
					this.endLoading();
				}
			}
		},
		async getDropdownListForWarehouse() {
			const { data } = await apiProvider.getDropdownListForWareHouse();
			if (data) {
				this.dropdownList.WarehouseId = data.Item1;
				this.filter.BulkInventoryPrp = data.Item2;
			}
		},
		async getWHListForUploadBulkInventoryDropDown() {
			const { data } = await apiProvider.getWHListForUploadBulkInventoryDropDown();
			if (data) {
				this.dropdownList.UploadWarehouseId = data;
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		decorateCells({ row, column }: { row: Row, column: any }) {
			if (column.label === this.LocalizePopisPoli(FILE_NAME)) {
				return { color: 'Blue', cursor: 'pointer'};
			}

			if(column.label === this.LocalizePopisPoli(ERROR_COUNT)){
				const errorColIndex: number = this.table.cellNames!.ERROR_COUNT;
				const errorVal = row.cells[errorColIndex];
				if(errorVal > 0)
				{
					return { color: 'Red', cursor: 'pointer', 
							fontWeight: 'bold', 
							animation: 'pulse normal none;' 
						};
				}
			}
			if (column.label === this.LocalizePopisPoli(STATUS)) {
				const statusColIndex: number = this.table.cellNames!.STATUS;
				const statusVal = row.cells[statusColIndex];
				if(statusVal == APPROVED)
					 return { color: 'green', fontweight:'bold' } ;
				if(statusVal == PENDING)
					 return { color: 'orange'};
				if(statusVal == REJECTED)
					 return { color: 'red'};
			}
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		showMessage(message: string) {
			showAlert({
				message,
				options: {
					type: 'error',
				},
			});
		},
		async handleClose() {
			if (this.isModified) {
				if (await this.getConfirmationForModifiedTable()) {
					this.closeClick();
				}
			} else {
				this.closeClick();
			}
		},
		async loadFilter() {
			return Promise.resolve();
		},
	},
	watch: {
		rows(rows: Row[]) {
			if (!this.localState.deepCopiedTableRows.length &&
				!_.isEqual(this.localState.deepCopiedTableRows, rows)) {
				this.localState.deepCopiedTableRows =
					JSON.parse(JSON.stringify(this.table.rows)) as Row[];
			}
		},
	},
});
